export default __webpack_public_path__ + "static/media/t-shirt.40017b7c.png";